/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Cognito API
 * Bank Relationship Management - Cognito
 * OpenAPI spec version: v1
 */
import type {
  AccessCredentialsDto,
  AccessFromRefreshTokenDto,
  CreatePasswordDto,
  CreatePasswordUserDataDto,
  GetApiV1AuthCreatePasswordUserDataParams,
  RequestRecoverPassswordDto,
  TokenResponse,
  ValidateTokenRequestDto,
  ValidateTokenResponseDto
} from '../schemas';

import { customInstance } from '.././mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getAuth = () => {
/**
 * @summary Retrieves user data for the password creation flow.
Validates the token and returns user information if valid.
 */
const getAuthCreatePasswordUserData = (
    params?: GetApiV1AuthCreatePasswordUserDataParams,
 options?: SecondParameter<typeof customInstance<CreatePasswordUserDataDto>>,) => {
      return customInstance<CreatePasswordUserDataDto>(
      {url: `/api/v1/auth/create-password/user-data`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Metodo para criar uma senha para o usuario logado.
 */
const patchAuthCreatePassword = (
    createPasswordDto?: CreatePasswordDto,
 options?: SecondParameter<typeof customInstance<TokenResponse>>,) => {
      return customInstance<TokenResponse>(
      {url: `/api/v1/auth/create-password`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: createPasswordDto
    },
      options);
    }
  /**
 * @summary Realiza o login e retorna um token JWT Bearer que sera utilizado no cabecalho de autorizacao { Authorization: 'Bearer {token aqui}' }.
 */
const postAuthLogin = (
    accessCredentialsDto?: AccessCredentialsDto,
 options?: SecondParameter<typeof customInstance<TokenResponse>>,) => {
      return customInstance<TokenResponse>(
      {url: `/api/v1/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accessCredentialsDto
    },
      options);
    }
  /**
 * @summary Gera um novo token JWT Bearer a partir de um token de atualiza��o (refresh token).
 */
const postAuthLoginRefreshToken = (
    accessFromRefreshTokenDto?: AccessFromRefreshTokenDto,
 options?: SecondParameter<typeof customInstance<TokenResponse>>,) => {
      return customInstance<TokenResponse>(
      {url: `/api/v1/auth/login/refresh-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accessFromRefreshTokenDto
    },
      options);
    }
  /**
 * @summary Envia uma solicitacao para recuperar a senha do usuario.
 */
const postAuthRecoverPassword = (
    requestRecoverPassswordDto?: RequestRecoverPassswordDto,
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/v1/auth/recover-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestRecoverPassswordDto
    },
      options);
    }
  /**
 * @summary Valida um token JWT e retorna informações sobre sua validade e dados contidos.
 */
const postAuthValidateToken = (
    validateTokenRequestDto?: ValidateTokenRequestDto,
 options?: SecondParameter<typeof customInstance<ValidateTokenResponseDto>>,) => {
      return customInstance<ValidateTokenResponseDto>(
      {url: `/api/v1/auth/validate-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: validateTokenRequestDto
    },
      options);
    }
  return {getAuthCreatePasswordUserData,patchAuthCreatePassword,postAuthLogin,postAuthLoginRefreshToken,postAuthRecoverPassword,postAuthValidateToken}};
export type GetApiV1AuthCreatePasswordUserDataResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['getAuthCreatePasswordUserData']>>>
export type PatchApiV1AuthCreatePasswordResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['patchAuthCreatePassword']>>>
export type PostApiV1AuthLoginResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['postAuthLogin']>>>
export type PostApiV1AuthLoginRefreshTokenResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['postAuthLoginRefreshToken']>>>
export type PostApiV1AuthRecoverPasswordResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['postAuthRecoverPassword']>>>
export type PostApiV1AuthValidateTokenResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['postAuthValidateToken']>>>
